export const TIMEOUT_DELAY = 60 * 1000; // 60s
export const TIMEOUT_ARE_YOU_SURE = 20 * 1000; // 20s
export const WHITE = 'white';
export const FFF = '#FFF';
export const UP = 'up';
export const DOWN = 'down';
export const TIME_OUT = {
  enter: 600,
  exit: 400,
};
export const DEFAULT_LANG = 'en-ca';

export const NO_CACHE = 'no-cache';
